import axios from 'axios';
import { ICity, ICityCollection, ICityCollectionParams, ICreateCity, IUpdateCity } from 'entities/City/City.models';

const basePath = 'city';
const adminPath = 'admin';

export const cityTransport = {
  get: (params: ICityCollectionParams): Promise<ICityCollection> => axios.get(`${basePath}`, { params }),
  getById: (id: number): Promise<ICity> => axios.get(`${adminPath}/${basePath}/${id}`),
  create: (payload: ICreateCity): Promise<ICity> => axios.post(`${adminPath}/${basePath}`, payload),
  update: ({ id, ...payload }: IUpdateCity): Promise<ICity> => axios.patch(`${adminPath}/${basePath}/${id}`, payload),
  detectCity: (): Promise<ICity> => axios.get(`${basePath}/detect`),
};
